document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-size-guide-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var modal = document.getElementById('aimma-size-guide');
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
    });
  });

  document.querySelectorAll('[data-size-guide-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      var modal = document.getElementById('aimma-size-guide');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var modal = document.getElementById('aimma-size-guide');
    if (modal && modal.classList.contains('is-open')) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }
  });
});
